import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from '@tanstack/react-table';
import { useMemo, useState } from 'react';

import { columnsData } from 'features/participants/config/tableColumnsData';
import { filterByUserName } from 'features/participants/utils';

const defaultSorting = [
  {
    id: 'nextSessionAppointment',
    desc: false,
  },
];

export const useParticipantsTable = (participants) => {
  const columns = useMemo(() => columnsData, []);
  const [sorting, setSorting] = useState(defaultSorting);
  const [globalFilter, setGlobalFilter] = useState('');

  return useReactTable({
    columns,
    data: participants,
    state: {
      sorting,
      globalFilter,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    filterFns: {
      filterByUserName,
    },
    globalFilterFn: 'filterByUserName',
    enableSortingRemoval: false,
    sortDescFirst: false,
  });
};
